import appRoles from "./constants/appRoles.json";

function normalizeRoles(roles) {
  if (!roles) return [];

  if (Array.isArray(roles)) {
    return roles.flatMap((role) => {
      if (typeof role === "string") return [role];
      if (role && typeof role === "object") {
        if (Array.isArray(role.roles)) return role.roles;
        if (typeof role.role === "string") return [role.role];
      }
      return [];
    });
  }

  if (typeof roles === "string") {
    try {
      const parsed = JSON.parse(roles);
      return normalizeRoles(parsed);
    } catch {
      return [roles];
    }
  }

  if (typeof roles === "object") {
    if (Array.isArray(roles.roles)) return roles.roles;
    if (typeof roles.role === "string") return [roles.role];
  }

  return [];
}

export function getPermissionsDetails(role, language) {
  const defaultLanguage = language || localStorage.getItem("language") || "en";
  const roles = normalizeRoles(role);
  const baseRoles = appRoles[defaultLanguage]?.baseRoles || appRoles.en.baseRoles;

  const rolePermissions = baseRoles.filter((entry) =>
    roles.some((currentRole) => entry.id.toLowerCase() === currentRole.toLowerCase()),
  );

  if (!rolePermissions.length) return null;
  if (rolePermissions.length === 1) return rolePermissions[0];

  return {
    id: rolePermissions.map((entry) => entry.id).join("_"),
    title: rolePermissions.map((entry) => entry.title).join(" / "),
    description: rolePermissions.map((entry) => entry.description).join(" "),
    capabilities: Array.from(
      new Set(rolePermissions.flatMap((entry) => entry.capabilities || [])),
    ),
    roles: rolePermissions,
  };
}